(function(){
  var track=document.getElementById('gtrack');
  var slides=Array.prototype.slice.call(track.children);
  var dots=Array.prototype.slice.call(document.querySelectorAll('.gdot'));
  var thumbs=Array.prototype.slice.call(document.querySelectorAll('.gthumb'));
  function idx(){return Math.round(track.scrollLeft/track.clientWidth);}
  function go(i){
    i=Math.max(0,Math.min(slides.length-1,i));
    track.scrollTo({left:i*track.clientWidth,behavior:'smooth'});
    sync(i);
  }
  function sync(i){
    dots.forEach(function(d,x){d.classList.toggle('on',x===i);});
    thumbs.forEach(function(t,x){t.classList.toggle('on',x===i);});
  }
  function bind(el,fn){
    el.addEventListener('click',function(e){e.preventDefault();fn();});
    el.addEventListener('touchend',function(e){e.preventDefault();fn();},{passive:false});
  }
  bind(document.getElementById('gprev'),function(){go(idx()-1);});
  bind(document.getElementById('gnext'),function(){go(idx()+1);});
  dots.concat(thumbs).forEach(function(el){
    bind(el,function(){go(parseInt(el.getAttribute('data-g'),10));});
  });
  var t;
  track.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){sync(idx());},80);},{passive:true});
  addEventListener('resize',function(){sync(idx());},{passive:true});

  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(e.isIntersecting){
        var el=e.target;
        var sibs=Array.prototype.filter.call(el.parentElement.children,function(c){
          return c.classList.contains('rv')&&!c.classList.contains('in');});
        var i=sibs.indexOf(el);
        el.style.transitionDelay=(i>0?Math.min(i,5)*80:0)+'ms';
        el.classList.add('in');io.unobserve(el);
      }
    });
  },{threshold:.07});
  Array.prototype.forEach.call(document.querySelectorAll('.rv'),function(el){io.observe(el);});

  var prog=document.getElementById('prog');
  addEventListener('scroll',function(){
    var h=document.documentElement;
    prog.style.width=(h.scrollTop/(h.scrollHeight-h.clientHeight)*100)+'%';
  },{passive:true});
})();